import { HttpEvent, HttpHeaders, HttpParams, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { SearchParams } from '../entities/search-params.entity';

@Injectable()
export abstract class ShAbstractHttpService {
    abstract head(
        endpoint: string,
        params?: SearchParams | HttpParams,
        headers?: HttpHeaders
    ): Observable<HttpResponse<void>>;
    abstract count(endpoint: string, params?: SearchParams | HttpParams): Observable<number>;

    abstract request<T>(endpoint: string, method: string, body: any): Observable<T>;

    abstract get<T>(
        endpoint: string,
        params?: SearchParams | HttpParams,
        headers?: HttpHeaders,
        retry?: boolean
    ): Observable<T>;

    abstract getText<T>(endpoint: string, params?: SearchParams | HttpParams): Observable<string>;
    abstract getBlob(endpoint: string, params?: SearchParams | HttpParams): Observable<Blob>;
    abstract getExternalBlob(url: string): Observable<Blob>;

    abstract post<T>(
        endpoint: string,
        data: any,
        headers?: HttpHeaders,
        params?: HttpParams,
        retry?: boolean
    ): Observable<T>;

    abstract postProgress<T>(endpoint: string, data: any): Observable<HttpEvent<T>>;
    abstract postResponse<T>(endpoint: string, data: any, headers?: HttpHeaders): Observable<HttpResponse<T>>;

    abstract put<T>(endpoint: string, data: any): Observable<T>;
    abstract patch<T>(endpoint: string, data: any, headers?: HttpHeaders): Observable<T>;
    abstract patchResponse<T>(endpoint: string, data: any, headers?: HttpHeaders): Observable<HttpResponse<T>>;

    abstract delete<T>(endpoint: string): Observable<T>;
    abstract delete<T>(endpoint: string, data?: any): Observable<HttpEvent<T>>;
}
